import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';
import copy from "copy-to-clipboard";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const ShareFolder: React.FC<ShareFolderProps> = ({url, toCopy}) => {

  return (
    <div className="mt-2 text-center">
      <h1><FormattedMessage {...defaultMessages.folderShareTitle} /></h1>
      <div className="folder-share-form">
        <input id="foo" value={url}/>
        <button className="btn btn-age" onClick={() => toCopy(url)}>
          <i className="fas fa-2x fa-copy"/>
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    url: `https://www.9thbuilder.com/builder/folders/${state.folder.id}/share`,
  }
};

const mapDispatchToProps = () => (
  {
    toCopy: (url: string) => copy(url)
  }
)

export default connect(mapStateToProps, mapDispatchToProps)(ShareFolder);

type ShareFolderProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
